import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  AccordionSummary,
  Typography,
  AccordionDetails,
  Accordion,
  InputLabel,
  FormHelperText, IconButton
} from '@material-ui/core'
import { useStyles } from '../Styles'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import FormSelectField from '../../../../FormFields/FormSelectField'
import { concatBranchAddress } from '../../../../utils/helpers'
import EditIcon from '@material-ui/icons/Edit'
import countryCodes from '../../../../configurations/country-codes'
import governates from '../../../../configurations/governates'
import cities from '../../../../configurations/cities'

const Issuer = ({ taxpayerData, formClasses, oldData, data, handleAddressDialog, formActions, locale, hasDrafted }) => {
  const classes = useStyles()
  const [currentIssuerBranchID, setCurrentIssuerBranchID] = React.useState(taxpayerData?.branches?.length ? taxpayerData?.branches[0].branch_number : {})
  const [currentIssuerBranchActivities, setCurrentIssuerBranchActivities] = React.useState([])
  const [firstTimeDraft, setFirstTimeDraft] = React.useState(!!hasDrafted)

  React.useEffect(() => {
      if (!!currentIssuerBranchID) {
        let branch = taxpayerData?.branches?.filter(item => item?.branch_number?.toString() === currentIssuerBranchID?.toString())
        let branchObj = branch?.length ? branch[0] : {}
        setCurrentIssuerBranchActivities(branchObj?.activity_codes || [])
        if (!!firstTimeDraft || currentIssuerBranchID?.toString() === oldData?.issuerBranchID?.toString()) {
          formActions.setFieldValue('issuerAddress', oldData?.issuerAddress)
          formActions.setFieldTouched('issuerAddress', true, false)
          setFirstTimeDraft(false)
        } else {
          if (!!Object.keys(branchObj || {}).length) {
            let country = countryCodes?.filter(country => country?.key?.toString() === (branchObj.address?.country || 'EG').toString())
            if (!!country?.length) {
              country = country[0]
            }
            let gov = [...governates, ...cities].filter((item) => branchObj.address?.governorate?.toString() === item.code?.toString() || branchObj.address?.governorate?.replaceAll(/ـ/gi, '')?.replaceAll(/أ|إ/gi, 'ا') === item[`name_${locale}` || 'name_en']?.replaceAll(/ـ/gi, '')?.replaceAll(/أ|إ/gi, 'ا'))
            gov = gov?.length ? gov[0][`name_${locale}` || 'name_en'] : branchObj.address?.governorate

            let city = [...cities, ...governates].filter((item) => branchObj.address?.city?.toString() === item.code?.toString() || branchObj.address?.city?.replaceAll(/ـ/gi, '')?.replaceAll(/أ|إ/gi, 'ا') === item[`name_${locale}` || 'name_en']?.replaceAll(/ـ/gi, '')?.replaceAll(/أ|إ/gi, 'ا'))
            city = city?.length ? city[0][`name_${locale}` || 'name_en'] : branchObj.address?.city

            let newData = {
              country: branchObj.address?.country || 'EG',
              countryName: country[`name_${locale}`] || '',
              governate: gov || '',
              regionCity: city || '',
              street: branchObj.address?.street_name || '',
              buildingNumber: branchObj.address?.building_number || '',
              floor: branchObj.address?.floor || '',
              room: branchObj.address?.room || '',
              landmark: branchObj.address?.landmark || '',
              postalCode: branchObj.address?.postal_code || '',
              additionalInformation: branchObj.address.additional_information || ''
            }
            setTimeout(()=>formActions.setFieldTouched('issuerAddress', true, true),50)
            // formActions.setFieldTouched('issuerAddress', true, true)
            formActions.setFieldValue('issuerAddress', newData)
          }
        }
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentIssuerBranchID])

  const issuerAddressCombined = React.useMemo(() => concatBranchAddress(formActions.values.issuerAddress), [formActions.values.issuerAddress]);

  return (
    <div className={classes.IssuerReceiverWrapper}>
      <Accordion defaultExpanded={true} elevation={0}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon/>}
          className={classes.IssuerReceiverHeaderWrapper}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <div className={classes.IssuerReceiverHeader}>
            <Typography className={classes.ItemHeading}>{data?.icon}{data?.title}</Typography>
          </div>
        </AccordionSummary>
        <AccordionDetails className={classes.IssuerReceiverDetailsWrapper}>
          <div className={formClasses.FormItem + ' info'}>
            <InputLabel><FormattedMessage id={'Fields.label.issuerName'}/>:</InputLabel>
            <div className={'info-data'}>
              <strong>{formActions.values.issuerName}</strong>
            </div>
          </div>
          <div className={formClasses.FormItem + ' info'}>
            <InputLabel><FormattedMessage id={'Fields.label.issuerID'}/>:</InputLabel>
            <div className={'info-data'}>
              <strong>{formActions.values.issuerID}</strong>
            </div>
          </div>
          <FormSelectField name={'issuerBranchID'} labelKey={'Fields.label.issuerBranchID'}
                           classes={formClasses} row setFilter={setCurrentIssuerBranchID}
                           formActions={formActions} required withKeyParenthesis
                           list={taxpayerData?.branches?.map((branch, index) => ({
                             ...branch,
                             key: branch?.branch_number
                           }))}/>

          <FormSelectField name={'taxpayerActivityCode'} labelKey={'Fields.label.taxpayerActivityCode'}
                           classes={formClasses} row
                           formActions={formActions} required
                           list={currentIssuerBranchActivities?.map(activity => ({
                             key: activity?.code,
                             name: activity?.description + ` (${activity?.code})`
                           }))}/>


          <div className={formClasses.FormItem + ' ' + formClasses.FormRow}>
            <Accordion elevation={2} className={formClasses.FormAccordion}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon/>}
                className={classes.AddressCollapseWrapper}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <div className={classes.ReceiverAddressWrapper}>
                  {!!Object.keys(formActions.values.issuerAddress || {}).length ?
                    <div className={formClasses.FormItem + ' info ' + formClasses.FormRow}>
                      <InputLabel><FormattedMessage id={'Fields.label.BranchAddress'}/>:</InputLabel>
                      <div className={'info-data'}>
                        <strong>{issuerAddressCombined}</strong>
                      </div>
                    </div>
                    : <Typography className={classes.ItemHeading}><FormattedMessage
                      id={'Fields.label.BranchAddress'}/></Typography>
                  }
                  <div>
                    <IconButton color="secondary" aria-label="Edit" onClick={(e) => handleAddressDialog(e, 'Issuer')}>
                      <EditIcon/>
                    </IconButton>
                  </div>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div className={formClasses.AddressInfoWrapper}>
                  {Object.keys(formActions.values.issuerAddress || {})?.map((column, index) => (
                    !!formActions.values.issuerAddress[column]?.trim() && !['country'].includes(column) &&
                    <div key={index} className={formClasses.FormItem + ' info '}>
                      <InputLabel><FormattedMessage id={`Issuer.Address.${column}`}/></InputLabel>
                      <div className={'info-data'}>
                        <strong>{formActions.values.issuerAddress[column]}</strong>
                      </div>
                    </div>
                  ))}
                </div>
              </AccordionDetails>
            </Accordion>
            {formActions.errors.issuerAddress && formActions.touched.issuerAddress &&
            <FormHelperText error={true}><FormattedMessage id='validationSchema.address.required'/></FormHelperText>
            }
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  )
}

export default Issuer
